/*globals med$*/
angular.module('sharable-dashboard.TagService', [
        'MW.Configuration'
    ])
    .service('TagService', ['$http', 'TAG_SERVICE_URL', function($http, TAG_SERVICE_URL) {
            'use strict';

            var tagServiceObj = {};

            /**
             * Responsible for getting all tags for the current user and company.
             * @returns {HttpPromise} The HTTPPromise that calls the MASF Tag Service to get all tags.
             */
            tagServiceObj.getAllTags = function getAllTags() {
                return $http({
                    url: TAG_SERVICE_URL,
                    method: 'GET',
                    params: {},
                    headers: {
                        'x-client-name': 'sharable-dashboard-web'
                      }
                });
            };

            // Start Narwhal api testing
            tagServiceObj.getTagWithId = function getTagWithId(tagId) {
                return $http({
                    url: '/tag/getTagWithId',
                    method: 'GET',
                    params: { tagId: tagId }
                });
            };

            tagServiceObj.hasTag = function hasTag(tagsArray, tag){
                return (tagsArray) ? (tagsArray.indexOf(tag.name) >= 0) : false;
            };

            return tagServiceObj;
        }
    ]);